import createImmutableSelector from 'lib/immutable/selector'
import { ITienditaLayout } from '../models'

// TODO: import Store type and add reducer type in Store interface
const getTienditaLayout = (state: any): ITienditaLayout => state.get('tienditaLayoutReducer')

export const tienditaLayoutSelector = createImmutableSelector(getTienditaLayout, (tienditaLayout) => tienditaLayout)
